import { gql } from 'graphql-tag';

export default gql`
  query GetCustomer($input: GetCustomerInput!) {
    getCustomer(input: $input) {
      first_name
      last_name
      cellphone
      email
    }
  }
`;
